export const SIDEBAR_SEARCH_LEAD = "sidebar search lead";
export const SIDEBAR_BUTTON_INVENTORY = "sidebar button inventory";
export const SIDEBAR_BUTTON_BULK_UPLOAD = "sidebar button bulk upload";
export const SIDEBAR_BUTTON_NOTIFICATIONS = "sidebar button notifications";
export const SIDEBAR_BUTTON_SUPPORT = "sidebar button support";
export const SIDEBAR_BUTTON_RULES = "sidebar button rules";
